import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, Renderer2, ViewChild } from '@angular/core';
import { CmsBannerComponent, OccEndpointsService } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { UserInfoService } from '../../spartacus/services/user-info.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-custom-saftey-info',
    templateUrl: './custom-saftey-info.component.html',
    styleUrls: ['./custom-saftey-info.component.scss'],
    standalone: false
})
export class CustomSafteyInfoComponent{ 
  @ViewChild('safetyInfoAnchor') safetyInfoAnchor!: ElementRef;
constructor(public component: CmsComponentData<CmsBannerComponent>,private el: ElementRef,private renderer: Renderer2,private userInfoService:UserInfoService,private cd:ChangeDetectorRef,private occEndpoints:OccEndpointsService){}
safteyinfodata: Observable<any> = this.component.data$;
isSticky: boolean = true;
showSticky: boolean = true;
 lastScrollY: number = 0;
 userInfo: any;
  // ngAfterViewInit() {
  //   this.checkSticky();  // Initialize on page load
  // }
  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.checkSticky();
  }
  @HostListener('click', ['$event'])
  onContentClick(event: Event) {
    const anchor = (event.target as HTMLElement)?.closest('a') as HTMLAnchorElement | null;
    if (!anchor) {
      return;
    }
    const href = anchor.getAttribute('href') || '';

    let pdf$: Observable<any> | null = null;
    if (/FluadPrescribingInfoPDF/i.test(href)) {
      pdf$ = this.userInfoService.getFluadPdf();
    } else if (/FlucelvaxPrescribingInfoPDF/i.test(href)) {
      pdf$ = this.userInfoService.getFlucelvaxPdf();
    } else if (/AfluriaPrescribingInfoPDF/i.test(href)) {
      pdf$ = this.userInfoService.getAfluriaPdf();
    }

    if (pdf$) {
      event.preventDefault();
      pdf$.subscribe((res) => {
        const repo = this.occEndpoints.buildUrl(res).replace('occ/v2/seqirusb2b-flu360/', '');
        window.location.href = repo;
      });
    }
  }
 
  checkSticky() {
    const anchor = document.getElementById('safetyInfoAnchor');
    const safetyInfo = document.getElementById('safetyInfo');
    if (anchor) {
      const scroll = window.scrollY;
      if (scroll !== this.lastScrollY) {  // Only update if there's a change
        const anchorTop = anchor.getBoundingClientRect().top + scroll + 120;
        this.isSticky = scroll <= anchorTop - window.innerHeight;
        this.lastScrollY = scroll;  // Update the last scroll position
      }
    }
  }
 

  // scrollToAnchor() {
  //   if (this.safetyInfoAnchor) {
 
  //     this.safetyInfoAnchor.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
  //   } else {
  //     console.error('Anchor element not found');
  //   }
  // }
  scrollToAnchor() {
  this.safetyInfoAnchor.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
 
  // Safari/iPhone fix: force exact alignment after smooth scroll
  setTimeout(() => {
    const y = this.safetyInfoAnchor.nativeElement.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({ top: y, behavior: 'auto' });
  }, 400); // delay lets smooth scroll finish
  }
  userLoggedIn: boolean = false;
  ngOnInit(){
    this.userInfoService.userLoggedIn$.subscribe(res=>{
   
      this.userLoggedIn = res;
      if(this.userLoggedIn){
        this.userInfoService.getUserData().subscribe(res=>{
          if(res){
          this.userInfo=res;
          }
        });
      }
      if(this.userInfo?.webEnabled === false){
        this.renderer.setStyle(document.querySelector('.SideContent'),'display','none');
       }
      this.cd.detectChanges();
    })
  }

}